import { useEffect, useCallback, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import AIPictures from "./AIPictures";
import ManualPictures from "./ManualPictures";
import ActivityTagContainer from "./ActivityTagContainer";
import DeleteIcon from "assets/icons/DeleteIcon";
import useAppSelector from "hooks/useAppSelector";
import useAppDispatch from "hooks/useAppDispatch";
import { getUnpublishedPictures } from "features/picture/pictureAction";
import {
  getAIPictureToBeChecked,
  getNonAIPictureToBeChecked,
} from "utilities/PictureStatusFilter";
import { DELETE_PICTURES_PATH } from "router/pathName";
import type { Picture } from "types/Pictures";

const Pictures = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();
  const fetchUnpublishedPictures = () => {
    const classId = parseInt(id || "");
    if (isNaN(classId)) return;

    dispatch(getUnpublishedPictures({ classId }));
  };
  const callFetchUnpublishedPictures = useCallback(fetchUnpublishedPictures, [
    id,
    dispatch,
  ]);
  useEffect(() => {
    callFetchUnpublishedPictures();
  }, [callFetchUnpublishedPictures]);

  // Listen for image edit success events
  useEffect(() => {
    const handleImageEditSuccess = (event: CustomEvent) => {
      console.log(
        "Image edit successful, refreshing pictures...",
        event.detail,
      );
      callFetchUnpublishedPictures();
    };

    window.addEventListener(
      "imageEditSuccess",
      handleImageEditSuccess as EventListener,
    );

    return () => {
      window.removeEventListener(
        "imageEditSuccess",
        handleImageEditSuccess as EventListener,
      );
    };
  }, [callFetchUnpublishedPictures]);

  const { pictures } = useAppSelector((state) => state.picture);

  const [checkedPictures, setCheckedPictures] = useState<Picture[]>([]);
  useEffect(() => {
    setCheckedPictures([
      ...getAIPictureToBeChecked(pictures),
      ...getNonAIPictureToBeChecked(pictures),
    ]);
  }, [pictures]);

  return (
    <div className="h-full space-y-3 lg:space-y-5">
      <AIPictures onRefreshPictures={callFetchUnpublishedPictures} />
      <ManualPictures onRefreshPictures={callFetchUnpublishedPictures} />
      <ActivityTagContainer pictures={checkedPictures} />
      <div className="flex justify-end">
        <button
          className="group w-fit flex justify-end items-center space-x-1 text-[#3b82f6]"
          onClick={() => navigate(`${DELETE_PICTURES_PATH}/${id}`)}
        >
          <DeleteIcon width={36} height={36} color={"#3b82f6"} />
          <p className="text-xl underline group-hover:no-underline">
            {t("_unpublished_picture_class._not_published_picture")}
          </p>
        </button>
      </div>
    </div>
  );
};

export default Pictures;
